const features = [
  {
    icon: 'ri-flashlight-line',
    title: '实时追踪热点',
    desc: '全时段监控各大平台最新动态，第一时间聚合黑料视频与爆料内容，确保你不错过任何一条重磅大瓜。每日更新200+条正片资源，让黑料在线观看快人一步。',
  },
  {
    icon: 'ri-movie-2-line',
    title: '高清正片直连',
    desc: '所有黑料视频均提供高清画质在线播放，无需下载、无需跳转第三方页面。直接点播即可流畅观看，黑料在线免费观看体验全新升级。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    desc: '平台严格过滤恶意广告与弹窗，全程清爽观影。免注册模式保护用户隐私，黑料在线视频播放环境干净安全，安心吃瓜无后顾之忧。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            为什么数百万吃瓜群众选择黑料在线
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((item, i) => (
            <div
              key={i}
              className="group bg-white rounded-2xl p-6 md:p-8 text-center transition-all duration-300 hover:bg-background-100/80 border border-background-200/60"
            >
              <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}